export async function googleTranslate(
  text: string,
  sourceLanguage = "auto",
  targetLanguage = "vi",
  options: { signal?: AbortSignal } = {}
): Promise<{ translation: string; sourceLanguage: string }> {
  const url = new URL("https://translate-pa.googleapis.com/v1/translate")
  url.search = new URLSearchParams({
    "params.client": "gtx",
    dataTypes: "TRANSLATION",
    key: "AIzaSyDLEeFI5OtFBwYBIoK_jj5m32rZK5CkCXA",
    "query.sourceLanguage": sourceLanguage,
    "query.targetLanguage": targetLanguage,
    "query.text": text,
  }).toString()
  let res: Response
  try {
    res = await fetch(url, { signal: options.signal })
  } catch {
    throw new Error("Không gọi được Google Translate. Kiểm tra kết nối mạng hoặc CORS.")
  }
  if (!res.ok)
    throw new Error(
      res.status === 429
        ? "Google giới hạn yêu cầu (429). Vui lòng chờ rồi tiếp tục dịch."
        : `Google Translate trả lỗi HTTP ${res.status}.`
    )
  let value: unknown
  try {
    value = await res.json()
  } catch {
    throw new Error("Google Translate trả JSON không hợp lệ.")
  }
  if (
    !value ||
    typeof value !== "object" ||
    !("translation" in value) ||
    typeof value.translation !== "string" ||
    !value.translation.trim() ||
    !("sourceLanguage" in value) ||
    typeof value.sourceLanguage !== "string" ||
    !value.sourceLanguage.trim()
  ) {
    throw new Error("Google Translate trả dữ liệu không đúng cấu trúc.")
  }
  return { translation: value.translation.trim(), sourceLanguage: value.sourceLanguage }
}

export async function translateBatch(
  segments: Array<{ id: number | string; text: string }>,
  sourceLanguage: string,
  options: { signal?: AbortSignal; translate?: typeof googleTranslate; shouldStop?: () => boolean } = {}
) {
  const translations: Array<{ id: number | string; translation: string }> = []
  let error: Error | null = null
  let cursor = 0
  const worker = async () => {
    while (!error && !options.signal?.aborted && !options.shouldStop?.()) {
      const segment = segments[cursor++]
      if (!segment) return
      try {
        const result = await (options.translate || googleTranslate)(segment.text, sourceLanguage, "vi", {
          signal: options.signal,
        })
        translations.push({ id: segment.id, translation: result.translation })
      } catch (cause) {
        error = cause instanceof Error ? cause : new Error("Dịch không thành công.")
      }
    }
  }
  await Promise.all([worker(), worker()])
  return { translations, error }
}
